import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Group } from 'src/app/common-class/pages';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-demographics',
  templateUrl: './demographics.component.html',
  styleUrls: ['./demographics.component.css'],
})
export class DemographicsComponent implements OnInit, OnDestroy {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() group: Group;
  @Input() DropDown: string;
  @Input() isMobile: boolean;
  @Input() MonthArray: string[];
  @Input() isNewParticipationButton: boolean;
  @Input() isResponseUpdate: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  isNgAfter: boolean;
  count: number = 0;
  dropDownlength: number;
  isNewParticipation: boolean;
  surveyFormat: number = 0;
  newParticipationBtnText: string;
  isAnsChange: boolean = false;
  isAutoScroll: boolean;
  isPreReadQn: boolean;
  resetPageSub: Subscription;
  isResetPage: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['JsonData'];
    if (change != undefined) {
      const curVal = JSON.stringify(change.currentValue);
      const preVal = JSON.stringify(change.previousValue);
      if (
        curVal != preVal &&
        preVal != undefined &&
        (this.isResetPage || this.isQuesionHideInQDL())
      ) {
        this.questions = JSON.parse(this.JsonData);
        this.isNgAfter = true;
        this.count = 0;
        this.ngAfterViewInit();
        this.isResetPage = false;
        this.questions = this.questions.filter((e) => !e.isHiddenQ);
      }
    }
  }

  constructor(private service: ParticipationDataService) {}

  ngOnInit() {
    if (this.questions == null) {
      if (this.JsonData) {
        this.questions = JSON.parse(this.JsonData);
      }

      if (this.group && this.group.answer_style === 0 && this.questions.length > 1) {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
      }

      const imgQn = this.questions.find((e) => e.sub_qno == 1);
      if (imgQn != undefined && imgQn != null) {
        this.imgQuestion = imgQn;
      }
      this.dropDownlength = this.questions.length;
    }
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.isAutoScroll = this.service.isAutoScroll;
    this.isPreReadQn = this.questions.filter((e) => e.population_type == 3).length > 0;
    this.questions = this.questions.filter((e) => !e.isHiddenQ);
  }

  ngAfterViewInit() {
    if (window.navigator.userAgent.indexOf('Chrome') != -1) {
      const answerParents = document.querySelectorAll('.answerParent');
      answerParents.forEach((el) => {
        (el as HTMLElement).style.width = 'calc(100% + 1px)';
      });
    }

    const id = 'dv_' + this.imgQuestion.UniqueNumber;
    let largestWidth = 0;
    let ReEnterWidth = 0;

    setTimeout(() => {
      const demographicsWrappers = document.querySelectorAll(`#${id} .demographics-wrapper`);
      
      demographicsWrappers.forEach((wrapper) => {
        const questionOptionWrapper = wrapper.querySelector('.question-option-wrapper');
        if (questionOptionWrapper) {
          const currentWidth = (questionOptionWrapper as HTMLElement).offsetWidth;
          if (currentWidth > largestWidth) {
            largestWidth = currentWidth + 35;
          }
        }
        
        const reenterWrapper = wrapper.querySelector('.question-option-wrapper.reenter');
        if (reenterWrapper) {
          ReEnterWidth = (reenterWrapper as HTMLElement).offsetWidth;
        }
      });
      
      if (largestWidth < ReEnterWidth) {
        largestWidth = ReEnterWidth;
      }

      if (largestWidth > 400) {
        largestWidth = 400;
      }
      
      if (!this.isMobile) {
        const allQuestionOptionWrappers = document.querySelectorAll(`#${id} .demographics-wrapper .question-option-wrapper`);
        allQuestionOptionWrappers.forEach((element) => {
          const el = element as HTMLElement;
          el.style.width = `${largestWidth}px`;
          el.style.minWidth = `${largestWidth}px`;
          el.style.maxWidth = `${largestWidth}px`;
        });
      }
      
      const optionWrappers = document.querySelectorAll(`#${id} .demographics-wrapper .question-option-wrapper`);
      optionWrappers.forEach((element) => {
        (element as HTMLElement).style.whiteSpace = 'normal';
      });
    }, 100);
    
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
        this.isResetPage = true;
      }
    });
  }

  ngOnDestroy() {
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  isQuesionHideInQDL(): boolean {
    return true;
  }

  UpdateQuestionsData(question: Questions) {
    if (question.AnswerText != null) {
      this.isAnsChange = true;
    }
    this.ChangeAnswersData.emit(question);
    const qn = this.questions.find((e) => e.UniqueNumber == question.UniqueNumber);
    this.questions[this.questions.indexOf(qn)] = question;
  }
  
  UpdateLoadingQuestionsData(question: Questions) {
    if (question.AnswerText != null) {
      this.isAnsChange = true;
    }
    this.ChangeLoadingAnswersData.emit(question);
    const qn = this.questions.find((e) => e.UniqueNumber == question.UniqueNumber);
    this.questions[this.questions.indexOf(qn)] = question;
  }

  AnsChangecall(isAnsChangecall: boolean) {
    this.isAnsChange = isAnsChangecall;
  }

  GetQuestionsString(question): string {
    return JSON.stringify(this.questions.find((e) => e.UniqueNumber == question.UniqueNumber));
  }

  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }

  getHiddenQuestions(questions: Questions, service: ParticipationDataService) {
    if (
      service.getGroupType().toLowerCase() == 'preview' &&
      service.getPreviewData().isShowHiddenQN
    ) {
      return true;
    } else {
      return (
        (questions.population_type != 2 && questions.population_type != 5 && !questions.isCQHide) || service.getisEditResponse() == true
      );
    }
  }

  ngOnChangesEventHandle() {
    if (this.count == 0) {
      this.ngAfterViewInit();
      this.count++;
    }
  }

  getDemoClass(question: Questions) {
    switch (question.DemographicFieldID) {
      case 1:
        return 'demoTitle';
      case 2:
        return 'demoFName';
      case 21:
        return 'demoFullName';
      case 3:
        return 'demoMName';
      case 4:
        return 'demoLName';
      case 5:
        return 'demoGender';
      case 7:
        return 'demoDOB';
      case 91:
        return 'demoStreet1';
      case 92:
        return 'demoStreet2';
      case 81:
        return 'demoAddress1';
      case 82:
        return 'demoAddress1';
      case 83:
      case 93:
        return 'demoCity';
      case 86:
        return 'demoCountry';
      case 94:
        return 'demoCounty';
      case 84:
      case 95:
        return 'demoState';
      case 85:
      case 96:
        return 'demoZip';
      case 97:
        return 'demoZip4';
      case 101:
      case 10:
        return 'demoTelePhone';
      case 221:
      case 22:
        return 'demoExtc';
      case 232:
      case 23:
        return 'demoFax';
      case 11:
        return 'demoEmail';
      default:
        return '';
    }
  }
  
  gotoNextQuestion(question: Questions, event) {
    if (
      this.questions.filter((e) => e.isValid).length == 0 &&
      this.questions.filter(
        (e) =>
          !e.isValid &&
          e.qtype == 'T' &&
          e.qsubtype == 31 &&
          e.isreenter == 1 &&
          e.otherAnswer == null &&
          e.AnswerText != null,
      ).length == 0
    ) {
      this.service.gotoNextQuestion(question, event);
    }
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  isQuestionsPostPopulated(): boolean {
    let postpopQues =  this.questions.filter((e) => e.population_type == 4 || e.population_type == 5);
    if(postpopQues.length > 0 && this.service.getisEditPostPop() == true) {
      return true;
    }
    return false;
  }
  isPostEditDisable(question:Questions):boolean{
    if(this.service.getisEditPostPop() ==true
      && (question.population_type != 4 && question.population_type != 5)){
      return true;
    }
    return false;
  }

}
